import { router } from '@inertiajs/react'
import { LOCALES, useLocale } from '@/i18n'

/**
 * EN | NL pill in the header. PATCH /locale stores the choice in a cookie
 * (and on the account when signed in), then redirects back to the same page,
 * which Inertia re-renders in the new language.
 */
export default function LanguageSwitcher({ compact = false }: { compact?: boolean }) {
  const current = useLocale()

  function choose(code: string) {
    if (code === current) return
    router.patch('/locale', { lang: code }, { preserveScroll: true })
  }

  return (
    <div
      role="group"
      aria-label="Language"
      style={{
        display: 'inline-flex',
        border: '1px solid #e6e6e2',
        borderRadius: 10,
        overflow: 'hidden',
        height: compact ? 34 : 40,
      }}
    >
      {LOCALES.map((l) => {
        const active = l.code === current
        return (
          <button
            key={l.code}
            type="button"
            onClick={() => choose(l.code)}
            aria-pressed={active}
            title={l.name}
            lang={l.code}
            style={{
              border: 'none',
              padding: '0 11px',
              fontFamily: 'inherit',
              fontSize: 13,
              fontWeight: 700,
              letterSpacing: '0.02em',
              cursor: active ? 'default' : 'pointer',
              background: active ? 'var(--lilu-ink)' : '#f3f2ef',
              color: active ? '#fff' : 'var(--lilu-ink)',
            }}
          >
            {l.label}
          </button>
        )
      })}
    </div>
  )
}
